import { updateEmailConfirmModal } from '@/actions';

const rollback = store => next => action => {
	if (action.type.endsWith('_ROLLBACK')) {
		if (store.getState().auth?.user && action.payload?.status === 412) {
			store.dispatch(updateEmailConfirmModal(true));
		}
	}
	return next(action);
};

export default rollback;
